export let fuwuData = {
  // 求职类别
  qiuzhileibie:[],
  // 性别要求
  isSex:["不限","男","女"],
  //有无
  options1: [
    { label: '有', value: '1' },
    { label: '无', value: '0' },
  ],
  options: [
    { label: '是', value: '1' },
    { label: '否', value: '0' },
  ],
  // 性别
  sex:["男","女"],
  // 岗位状态
  gangweizhuangtai:['有效','无效','数据不完整'],
  // 工作类型
  workType:['专职','非专职'],
  // 就业区域
  jobArea:['县内','县外省内','珠三角','长三角','京津冀','境外','其它'],
  // 年龄
  age_:['18-30','31-40','41-50','51-60'],
  // 面试方式
  interviewType:['现场面试','QQ','微信','云视频'],
  // 服务
  fuwu:['招聘','求职','律师','教育','培训','融资','投资','招商','加盟','租房','售房','汽车','交友','电商','美食','旅游','健康'],
  // 年龄
  age:['不限','18-30岁以下','30-40岁','40-50岁','50岁以上'],
  // 学历
  education:['不限','高中及以下','中专','大专','本科','硕士','博士','其它'],
  education_:['高中及以下','中专','大专','本科','硕士','博士','其它'],
  // 学历
  dwzp_xl: ['中专','大专','本科','硕士','博士','高中','其它'],
  // 案件类型1
  laytype1:['求助','不限','民事','刑事','行政','房产','建筑','婚姻','债务','劳动','交通','顾问','医疗','经济','合同','大案','涉外'],
  // 案件类型2
  laytype2:['民事','刑事','行政','房产','建筑','婚姻','债务','劳动','交通','顾问','医疗','经济','合同','大案','涉外'],
  // 经验
  express:['不限','3年以下','3-5年','5-10年','10年以上'],
  //工作经验
  workexperience:['3年以下','3-5年','5-10年','10年以上'],
  // 教育性质
  hireProperty:['不限','全日制','电大','成教','函授','网络教育','其它'],
  // 薪资水平 =>对于职位发布者而言,薪资没有'不限'的选项
  gongzishuiping:['面议','3k以下','3k-8k','8k-15k','15k以上'],
  // 薪资水平要求
  isgongzishuiping:['不限','面议','3k以下','3k-8k','8k-15k','15k以上'],
  // 薪资
  xinzi:['面议','4k以下','4k-6k','6k-10k','10k-15k','15k以上'],
  // 薪资要求
  isXinzi:['不限','面议','3k以下','3k-8k','8k-15k','15k以上'],
  // 职位类型
  zhiweitype:['不限','管理类','技术类','财经类','行政类','服务类','营销类','普工类','教育类','医务类','金融类','中介类','建筑类','法律类','其它类'],
  zhiweitype_:['管理类','技术类','财经类','行政类','服务类','营销类','普工类','教育类','医务类','金融类','中介类','建筑类','法律类','其它类'],
  // 职位类别
  zhiweileibie:['不限','全职','兼职','实习','钟点'],
  zhiweileibie_:['全职','兼职','实习','钟点'],
  // 行业
  suoshuhangye3g:['不限','IT科技｜网络','金融｜证券｜保险','生产｜加工｜制造','医药｜医院｜药业','健身｜保健｜美容','广告｜媒介｜营销','房产｜物业｜建筑｜装饰','电子｜通讯｜通信','商场｜超市｜百货','汽车｜物流｜运输','食品｜快消｜零售','中介｜咨询｜服务','酒店｜餐饮｜娱乐','教育｜培训','其它'],
  suoshuhangye3g_:['IT科技｜网络','金融｜证券｜保险','生产｜加工｜制造','医药｜医院｜药业','健身｜保健｜美容','广告｜媒介｜营销','房产｜物业｜建筑｜装饰','电子｜通讯｜通信','商场｜超市｜百货','汽车｜物流｜运输','食品｜快消｜零售','中介｜咨询｜服务','酒店｜餐饮｜娱乐','教育｜培训','其它'],
  // 班次
  banci:['不限','白班','晚班','周末班','其它'],
  // 创业状态
  xiangmustatus:['不限','种子期','初创期','发展期','扩展期','成熟期','其它'],
  // 投资方式
  touzitype:['不限','股权投资','债权投资','天使投资','风险投资','产业投资','其它'],
  // 房子类型
  housetype:['不限','单间','套一','套二','套三','别墅','商务楼','其它'],
  // 房子装修
  housezhuangxiu:['不限','简装','精装','一般','清水房','其它'],
  // 汽车类型
  cartype:['不限','两厢','三厢','商务','越野','货车','客车','其它'],
  // 汽车价格
  carprice:['10k以下','10k-20k','20-50k','50-100k','100k以上'],
  // 交友学历
  friendeducation:['不限','高中及以下','中专','大专','本科','硕士','博士','其它'],
  // 美食类别
  foodtype:['不限','中餐','西餐','火锅','小吃','特色','其它'],
  // 外卖方式
  getfoodtype:['不限','送餐入户','自行领取','其它'],
  // 外卖 预定状态
  orderStatus:['正在预定','已满'],
  // 健康 预定状态
  healthOrderStatus:['未治疗','治疗中','已治疗'],
  // 健康 适宜人群
  okPersons:['不限','所有人','幼儿','儿童','青少年','青年','中年','老年'],
  //能力
  ability:['优','良','一般','较差'],
  //婚否
  ismarriage:['已婚','未婚'],
  // 招聘部门
  zhaopinbumen:['人事部','市场部','研发部','公关部','财务部','法务部','其它'],
  // 招生状态
  hireStatus:['未招满','已招满'],
  //诉讼类型
  laytype:[
    {label:'劳动维权',value:'1'},
    {label:'民事诉讼',value:'2'},
    {label:'刑事诉讼',value:'3'},
    {label:'行政诉讼',value:'4'},
  ],
  danweijibie: [
    { label: '省级', value: '0' },
    { label: '市级', value: '0' },
    { label: '县级及以下', value: '0' },
  ],
  //汽车类型
  carType:['两厢','三厢','商务','越野','货车','客车','其它',],
  // 汽车进展状态
  carStatus:['未卖车','正在卖车','已卖车'],
  //付款方式
  fukuanfangshiMapList: ['一次性','银行按揭'],
  //招商状态
  attractInvestmentStatus:['正在招商','停止招商'],
  //加盟状态
  jiamengStatus:['正在加盟','停止加盟'],
  //融资状态
  rongziStatus:['正在融资','停止融资'],
  //投资状态
  touziStatus:["正在投资","停止投资"],
  //投资方式
  touzifangshi:['不限','股权投资','债权投资','天使投资','风险投资','产业投资','其它'],
  // 装修情况
  renovation:['不限','简装','精装','一般','清水房','其它'],
  //房屋朝向
  direct:['正北','东北','正东','东南','正南','西南','正西','西北',],
  // 租金分层
  rentcash:['不限','≤1000元','1000-1500元','1500-2000元','2000-2500元','2500-3000元','3000-5000元','≥5000元'],
  //售房状态
  saleHouseStatus:['未出售','出售'],
  // 租房状态
  renthousestatus:['出租','未出租'],
  // 租房进展
  renttime:['未出租','正在出租','出租完毕'],
  //售房进展
  progressStatus:['未卖房','正在卖房','已卖房'],
  // 商品类别   电商
  catalog:['保健品','护具','食品','礼品','工艺品','装饰品','日用品','生鲜','宠物用品','宠物食品','服饰','厨具','刀具','餐具','家具','数码','配饰','家纺','乐器','玩具'],
  //公司性质
  companyType:["国有企业","集体企业","私营企业","个体工商户","合伙企业","联营企业","股份合作制企业","有限责任公司","股份有限公司"],
 
  //网站全局文章分类
  overallArticle:[
    {text:"知识产权",catalog:"knowledge"},
    {text:"网站管理",catalog:"website"},
    {text:"隐私保护",catalog:"privacy"},
    {text:"特别声明",catalog:"especially"},
    {text:"注册登录",catalog:"signUp"},
    {text:"单位会员",catalog:"companyVip"},
    {text:"个人会员",catalog:"personalVip"},
    {text:"如何视频",catalog:"video"}
  ],
  //律师申请审核状态
  layerApplyStatus:[
    {label:'待审核',val:1},
    {label:'同意',val:2},
    {label:'拒绝',val:3},
  ],
  //企业申请审核状态
  companyApplyStatus:[
    {label:'待审核',value:0},
    {label:'同意',value:1},
    {label:'拒绝',value:2},
  ]
}